import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Mfa_Status, sendAppMfaCode } from '@chegg/one-auth-sdk';
import { isGqlError, isPxError } from '@chegg/one-auth-sdk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleGeneralError } from "./steps/error";
import { handleOnboarding } from "./steps/onboarding";
import { handleSent } from "./steps/sent";
import { factorSelectionSlice } from "../slices/factorSelection";
import { changeRoute } from "../slices/router";
import { EventTypes, recordEvents } from "../../utils/newRelic/newRelicEvents";
import { initiatePx } from "../../utils/pxUtils";
import { handleToastMessage } from "./utils/orchestrator.utils";
export { orchestrator };
async function orchestrator(getState, dispatch) {
  try {
    dispatch(factorSelectionSlice.actions.setMfaByAppButtonLoader(true));
    var _getState$authParams = getState().authParams,
      cheggMfaToken = _getState$authParams.cheggMfaToken,
      uuid = _getState$authParams.uuid;
    recordEvents(_defineProperty({}, EventTypes.mfaByAppStartOnBoarding, undefined));
    var response = await sendAppMfaCode(cheggMfaToken, uuid);
    dispatch(factorSelectionSlice.actions.setMfaByAppButtonLoader(false));
    switch (response.status) {
      case Mfa_Status.ONBOARDING:
        recordEvents(_defineProperty({}, EventTypes.mfaByAppStatusOnBoarding, {}));
        await handleOnboarding(getState, dispatch, response);
        break;
      case Mfa_Status.SENT:
        recordEvents(_defineProperty({}, EventTypes.mfaByAppStatusSent, undefined));
        await handleSent(getState, dispatch);
        break;
      case Mfa_Status.BLOCKED:
        // Note❗️: this scenario is theoretical only, api won't return this status
        recordEvents(_defineProperty({}, EventTypes.mfaByAppStatusBlocked, undefined));
        handleGeneralError(dispatch);
        break;
      default:
        recordEvents(_defineProperty({}, EventTypes.mfaByAppGeneralError, undefined));
        handleGeneralError(dispatch);
        break;
    }
  } catch (e) {
    var error = e;
    recordEvents(_defineProperty({}, EventTypes.mfaByAppOrchestratorException, {
      error: e
    }));
    if (isPxError(error)) {
      recordEvents(_defineProperty({}, EventTypes.mfaByAppPxTriggered, {}));
      var onPxSuccessCb = function onPxSuccessCb() {
        recordEvents(_defineProperty({}, EventTypes.mfaByAppOrchestratorPxSuccess, {}));
        dispatch(changeRoute('/'));
        orchestrator(getState, dispatch);
      };
      initiatePx(error, dispatch, 'factor_selector', 'CHGG', onPxSuccessCb);
    } else {
      if (isGqlError(error) && error.code === 'otp_api_error') {
        recordEvents(_defineProperty({}, EventTypes.mfaByAppSentStatusBlocked, undefined));
        handleToastMessage(dispatch, 'blocked');
      } else {
        handleGeneralError(dispatch);
      }
      dispatch(factorSelectionSlice.actions.setMfaByAppButtonLoader(false));
    }
  }
}
export var startOrchestrator = createAsyncThunk('orchestrator', async function (_, _ref) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  return orchestrator(getState, dispatch);
});